import {FC, memo, useEffect, useMemo, useState} from "react";
import { ProjectsGridNew } from "../../../components/grids";
import { useProjectsList } from "../../../hooks/api/useProjectsByFilter";
import { computeProjectMapTile } from "../../../helpers/types/computed/ComputedProject";
import { useTranslation } from "react-i18next";
import { LayoutConst, bArray, bTag } from "../../../../core";
import { ProjectStatusPublished } from "../../../helpers/projectStatus";
import styled from "styled-components";
import { Colors, FInter } from "@brg/ui";
import { CreateLinkTo } from "../../../constants/linkTo";
import { Project } from "@brg/api";
import { Link } from "react-router-dom";
import { AGEYTOMESH_TAG_ID } from "../../../constants/misc";
import { AppTester } from "supporting";
import { ItemType } from "shared/constants/itemType";

export const AuthorProjectSectionWrapper = styled.div`
  max-width: 1152px;
  // margin: 120px auto 0;
  margin: 48px auto 0;

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    max-width: 888px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin: 16px auto 0 auto;
    max-width: 888px;
    width: calc(100% - 32px);
    padding: 0;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    // margin: 24px 0 0 0;
    margin: 48px 0 0 0;
    padding: 0 10px;
    // width: calc(100% - 20px);
    width: 100%;
  }
`;

const Title = styled(FInter.SectionTitle)`
  display: flex;
  flex-wrap: wrap;
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;

  .prefix-title {
    margin-right: 8px;
  }
  color: ${({ theme }) => theme.projectView.titleColor};

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 29px;
  }
  
  @media (max-width: 940px) {
    font-size: 24px;
    line-height: 26px;

    .prefix-title {
      margin-right: 6px;
    }
  }
`

const AuthorName = styled.span`
  color: ${({ theme }) => theme.projectView.categoryText};

  &:hover {
    color: ${({ theme }) => theme.icon.hover};
  }

  &:active {
    color: ${({ theme }) => theme.icon.active};
  }
`

const Header = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

const PSOtherProjects: FC<{ project: Project, setIsEmptyProjectTags: (val: boolean) => void }> = ({ project, setIsEmptyProjectTags }) => {
  const { i18n, t } = useTranslation();
  const [time, setTime] = useState(Date.now());

  const isGeography = AppTester.isGeograffee();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isLPU = AppTester.isLPUDesign();
  //const tagId = project?.tagsID?.[0];

  const tag = useMemo(() => {
    if (isGeography) {
      //@ts-ignore
      return project?.tags?.find(x => !!x.point) ?? project?.tags?.[0];
    } else {
      //@ts-ignore
      return project?.tags?.find(x => !x.point) ?? project?.tags?.[0];
    }
  }, [isGeography, project])

  const projectsListFilter = useMemo(() => ({
    tagIds: [tag?.tagId],
    excludeProjectIds: [project?.projectId],
    projectFilter: 1,
    globalTypes: ['student', 'Cooperator', 'Employee', 'Student'],
    projectStatus: [1],
    isLite: true,
    limit: 4,
    contexts: isAgeyTomesh ? ['ageytomesh'] : (isGalllleryArt ? ['galllleryart'] : ['hsedesign']),
    isContextIgnored: false,
    ...(isLPU && {
      globalTypes: ['lpuemployee'],
    }),
  }), [project, tag, isAgeyTomesh, isGalllleryArt]);

  const [allProjects] = useProjectsList(projectsListFilter, i18n.language, time);

  const publishedProjects = useMemo(
    () =>
      bArray.isArray(allProjects?.data)
        ? allProjects!.data.filter(ProjectStatusPublished)
        : [],
    [allProjects]
  );

  const filteredProjects = useMemo(
    () => publishedProjects.filter(({ projectId }) => projectId !== project.projectId),
    [publishedProjects, project]
  );
  // useEffect(() => {
  //   setIsEmptyProjectTags(filteredProjects.length < 1)
  // }, [filteredProjects])

  // if (filteredProjects.length < 1) {
  //   return null;
  // }

  useEffect(() => {
    setIsEmptyProjectTags(publishedProjects.length < 1)
  }, [publishedProjects])

  // useEffect(() => {
  //   setTime(Date.now());
  // }, [project]);

  if (publishedProjects.length < 1) {
    return null;
  }

  //onst tag = project?.tags?.[0];
  // @ts-ignore
  const target = (tag?.tagId === AGEYTOMESH_TAG_ID || tag?.isTeamTag) ? '_blank' : '';
  
  return (
    <AuthorProjectSectionWrapper>
      <Header>
        <Title>
          <span className={'prefix-title'}>{`${t('more_projects_in')} `}</span>
          <Link to={CreateLinkTo.tag(tag?.tagId)} target={target}>
            <AuthorName>
              {bTag.title(tag)}
            </AuthorName>
          </Link>
        </Title>
      </Header>
      {/* @ts-ignore */}
      <ProjectsGridNew projects={filteredProjects.slice(0, 4).map(computeProjectMapTile)} itemType={ItemType.other}/>
    </AuthorProjectSectionWrapper>
  );
};

export default memo(PSOtherProjects);
import {FC, memo, useEffect, useMemo, useState} from "react";
import { ProjectsGridNew } from "../../../components/grids";
import { useProjectsList } from "../../../hooks/api/useProjectsByFilter";
import { computeProjectMapTile } from "../../../helpers/types/computed/ComputedProject";
import { useTranslation } from "react-i18next";
import { LayoutConst, bArray, bTag } from "../../../../core";
import { ProjectStatusPublished } from "../../../helpers/projectStatus";
import styled from "styled-components";
import { Colors, FInter } from "@brg/ui";
import { CreateLinkTo } from "../../../constants/linkTo";
import { Project } from "@brg/api";
import { Link } from "react-router-dom";
import { AGEYTOMESH_TAG_ID } from "../../../constants/misc";
import { AppTester } from "supporting";
import { ItemType } from "shared/constants/itemType";

export const AuthorProjectSectionWrapper = styled.div`
  max-width: 1152px;
  // margin: 120px auto 0;
  margin: 48px auto 0;

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    max-width: 888px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin: 16px auto 0 auto;
    max-width: 888px;
    width: calc(100% - 32px);
    padding: 0;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    // margin: 24px 0 0 0;
    margin: 48px 0 0 0;
    padding: 0 10px;
    // width: calc(100% - 20px);
    width: 100%;
  }
`;

const Title = styled(FInter.SectionTitle)`
  display: flex;
  flex-wrap: wrap;
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;

  .prefix-title {
    margin-right: 8px;
  }
  color: ${({ theme }) => theme.projectView.titleColor};

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 29px;
  }
  
  @media (max-width: 940px) {
    font-size: 24px;
    line-height: 26px;

    .prefix-title {
      margin-right: 6px;
    }
  }
`

const AuthorName = styled.span`
  color: ${({ theme }) => theme.projectView.categoryText};

  &:hover {
    color: ${({ theme }) => theme.icon.hover};
  }

  &:active {
    color: ${({ theme }) => theme.icon.active};
  }
`

const Header = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

const PSOtherProjects: FC<{ project: Project, setIsEmptyProjectTags: (val: boolean) => void }> = ({ project, setIsEmptyProjectTags }) => {
  const { i18n, t } = useTranslation();
  const [time, setTime] = useState(Date.now());

  const isGeography = AppTester.isGeograffee();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isLPU = AppTester.isLPUDesign();
  //const tagId = project?.tagsID?.[0];

  const tag = useMemo(() => {
    if (isGeography) {
      //@ts-ignore
      return project?.tags?.find(x => !!x.point) ?? project?.tags?.[0];
    } else {
      //@ts-ignore
      return project?.tags?.find(x => !x.point) ?? project?.tags?.[0];
    }
  }, [isGeography, project])

  const projectsListFilter = useMemo(() => ({
    tagIds: [tag?.tagId],
    excludeProjectIds: [project?.projectId],
    projectFilter: 1,
    globalTypes: ['student', 'Cooperator', 'Employee', 'Student'],
    projectStatus: [1],
    isLite: true,
    limit: 4,
    contexts: isAgeyTomesh ? ['ageytomesh'] : (isGalllleryArt ? ['galllleryart'] : ['hsedesign']),
    isContextIgnored: false,
    ...(isLPU && {
      globalTypes: ['lpuemployee'],
    }),
  }), [project, tag, isAgeyTomesh, isGalllleryArt]);

  const [allProjects] = useProjectsList(projectsListFilter, i18n.language, time);

  const publishedProjects = useMemo(
    () =>
      bArray.isArray(allProjects?.data)
        ? allProjects!.data.filter(ProjectStatusPublished)
        : [],
    [allProjects]
  );

  const filteredProjects = useMemo(
    () => publishedProjects.filter(({ projectId }) => projectId !== project.projectId),
    [publishedProjects, project]
  );
  // useEffect(() => {
  //   setIsEmptyProjectTags(filteredProjects.length < 1)
  // }, [filteredProjects])

  // if (filteredProjects.length < 1) {
  //   return null;
  // }

  useEffect(() => {
    setIsEmptyProjectTags(publishedProjects.length < 1)
  }, [publishedProjects])

  // useEffect(() => {
  //   setTime(Date.now());
  // }, [project]);

  if (publishedProjects.length < 1) {
    return null;
  }

  //onst tag = project?.tags?.[0];
  // @ts-ignore
  const target = (tag?.tagId === AGEYTOMESH_TAG_ID || tag?.isTeamTag) ? '_blank' : '';
  
  return (
    <AuthorProjectSectionWrapper>
      <Header>
        <Title>
          <span className={'prefix-title'}>{`${t('more_projects_in')} `}</span>
          <Link to={CreateLinkTo.tag(tag?.tagId)} target={target}>
            <AuthorName>
              {bTag.title(tag)}
            </AuthorName>
          </Link>
        </Title>
      </Header>
      {/* @ts-ignore */}
      <ProjectsGridNew projects={filteredProjects.slice(0, 4).map(computeProjectMapTile)} itemType={ItemType.other}/>
    </AuthorProjectSectionWrapper>
  );
};

export default memo(PSOtherProjects);
